<template>

    <v-page-section padded>
        <template #title>
            <span class="text-danger">Delete Account</span>
        </template>
        <template #body>
            <transition name="modal">
                <v-modal-user-delete v-if="showModal == 'user-delete'" />
            </transition>
            <v-notice size="sm" message="Permanently delete your account. This action cannot be undone" />
        </template>
        <template #footer>
            <v-button size="sm" btn-style="danger" @click.native="deleteUser">Delete Account</v-button>
        </template>
    </v-page-section>

</template>

<script>

import ModalUserDelete from '@modals/user/ModalUserDelete';

export default {

    components: {
        'v-modal-user-delete': ModalUserDelete,
    },

    methods: {

        deleteUser() {
            this.$store.commit('showModal', 'user-delete');
        },

    },

}

</script>
